// FolderPicker — escolhe a pasta/repo no Mac onde o dispatch roda (cwd).
// Lista as pastas que o Mac anuncia (GET /runner/roots); sempre mantém o campo
// de digitar como fallback. value = path (string), onChange(path).

export default function FolderPicker({ roots = [], value = '', onChange }) {
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor="dispatch-folder" className="text-xs text-apolo-textTertiary">
        Pasta no Mac (onde rodar) — opcional
      </label>
      {roots.length > 0 && (
        <div className="flex flex-wrap gap-1" role="group" aria-label="Pastas recentes">
          {roots.slice(0, 8).map((r) => (
            <button
              key={r.path}
              type="button"
              aria-pressed={value === r.path}
              onClick={() => onChange(r.path)}
              className={`rounded-md border px-2 py-1 text-xs transition ${
                value === r.path
                  ? 'border-apolo-accent text-apolo-textPrimary'
                  : 'border-apolo-borderSubtle text-apolo-textSecondary hover:text-apolo-textPrimary'
              }`}
            >
              {r.label || r.path}
            </button>
          ))}
        </div>
      )}
      <input
        id="dispatch-folder"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="/Users/voce/projeto"
        spellCheck={false}
        autoCapitalize="off"
        autoCorrect="off"
        className="w-full rounded-lg border border-apolo-borderSubtle bg-apolo-surface2 px-3 py-2 text-sm text-apolo-textPrimary focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-accent/50"
      />
    </div>
  );
}
